function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-376.366 -262.555)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M381.177,277.948H395.07a.93.93,0,0,0,.129-.009A5.8,5.8,0,0,0,398.6,268a5.709,5.709,0,0,0-3.447-1.585.246.246,0,0,1-.191-.12,7.684,7.684,0,0,0-14.1,2.294.252.252,0,0,1-.227.2,4.589,4.589,0,0,0-4.263,4.57,4.319,4.319,0,0,0,1.236,3.21A5.475,5.475,0,0,0,381.177,277.948Z",
  fill: "#03ade8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M393.367,275.937a1.519,1.519,0,0,0-1.286-1.485.25.25,0,0,1-.214-.247v-1.018a3.5,3.5,0,0,0-7,0h0V274.2a.25.25,0,0,1-.213.247,1.519,1.519,0,0,0-1.287,1.485v5.5a1.5,1.5,0,0,0,1.5,1.5h7a1.5,1.5,0,0,0,1.5-1.5Zm-5,4.25a1,1,0,1,1,1-1A1,1,0,0,1,388.367,280.187Zm-1.5-7a1.5,1.5,0,0,1,3,0v1a.25.25,0,0,1-.25.25h-2.5a.25.25,0,0,1-.25-.25Z",
  fill: "#008bce"
})));

var SvgCloudSecuirityEngineer = function SvgCloudSecuirityEngineer(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24.002,
    height: 20.383,
    viewBox: "0 0 24.002 20.383",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCloudSecuirityEngineer, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cloud_secuirity_engineer.9f8b375b.svg";
export { ForwardRef as ReactComponent };